import { useState } from "react";

function UnlockingMarketSecretsModule() {
  const [activeModule, setActiveModule] = useState(null);

  const toggleModule = (index) => {
    setActiveModule(activeModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to Market Secrets",
      content: [
        "Overview of market dynamics and the hidden forces driving price action.",
        "Why uncovering market secrets can transform your trading success.",
      ],
    },
    {
      title: "Module 2: The Psychology of Market Movements",
      content: [
        "Understanding the collective psychology of market participants.",
        "How fear, greed, and herd behavior drive price trends and reversals.",
      ],
    },
    {
      title: "Module 3: Hidden Patterns in Price Action",
      content: [
        "Recognizing subtle price patterns that often precede major moves.",
        "Spotting early signs of trend changes and breakout opportunities.",
      ],
    },
    {
      title: "Module 4: The Role of Market Sentiment",
      content: [
        "How to gauge market sentiment using news, indicators, and crowd behavior.",
        "Identifying the 'mood' of the market to forecast potential price movements.",
      ],
    },
    {
      title: "Module 5: Insider and Institutional Moves",
      content: [
        "How institutional traders and insiders influence market trends.",
        "Techniques for spotting smart money movements and using them to your advantage.",
      ],
    },
    {
      title: "Module 6: Volume as a Market Secret",
      content: [
        "How to read volume and its relationship to price movements.",
        "Using volume spikes and trends to confirm or invalidate price patterns.",
      ],
    },
    {
      title: "Module 7: Advanced Technical Analysis",
      content: [
        "Advanced charting techniques: Fibonacci, Gann, and Elliott Wave theory.",
        "How to unlock deeper market insights by analyzing price charts in unconventional ways.",
      ],
    },
    {
      title: "Module 8: The Power of Market Correlations",
      content: [
        "How correlated assets can unlock market secrets (stocks, commodities, and currencies).",
        "Using cross-market analysis to predict moves and find hidden opportunities.",
      ],
    },
    {
      title: "Module 9: Timing the Market with Cycle Analysis",
      content: [
        "Understanding market cycles and how they affect price movements.",
        "Applying cycle theory to predict trend continuations and reversals.",
      ],
    },
    {
      title: "Module 10: Unseen Support and Resistance Levels",
      content: [
        "Identifying hidden support and resistance zones that aren’t obvious to the average trader.",
        "Using these levels to time your entries and exits more effectively.",
      ],
    },
    {
      title: "Module 11: Using Indicators to Unlock Market Insights",
      content: [
        "Combining leading and lagging indicators to find reliable trade setups.",
        "Unlocking the secret potential of tools like RSI, MACD, and Bollinger Bands.",
      ],
    },
    {
      title: "Module 12: Uncovering Market Divergence and Convergence",
      content: [
        "How divergence between price and indicators reveals potential market shifts.",
        "Trading strategies based on divergence signals from key technical indicators.",
      ],
    },
    {
      title: "Module 13: Risk Management: The Key to Unlocking Long-Term Success",
      content: [
        "Advanced risk management secrets: position sizing, trailing stops, and diversification.",
        "How professional traders use risk management as their secret weapon for consistent profits.",
      ],
    },
    {
      title: "Module 14: Mastering Market Fundamentals",
      content: [
        "Understanding the economic, political, and financial factors that shape markets.",
        "Using fundamental analysis to uncover long-term market trends and opportunities.",
      ],
    },
    {
      title: "Module 15: Putting It All Together: Your Trading Edge",
      content: [
        "Developing a holistic trading strategy that incorporates all the market secrets learned.",
        "Continuous improvement through backtesting, journaling, and adapting to new market conditions.",
      ],
    },
  ];

  return (
    <div className="container py-5">
      <h1 className="text-center mb-4">Unlocking Market Secrets</h1>
      <p className="text-center text-muted mb-5">
        Discover the hidden forces behind market movements and unlock your trading potential.
      </p>
      <div className="accordion">
        {modules.map((module, index) => (
          <div key={index} className="mb-3">
            <div
              className="p-3 bg-secondary text-white d-flex justify-content-between align-items-center"
              onClick={() => toggleModule(index)}
              style={{
                cursor: "pointer",
                borderRadius: "5px",
              }}
            >
              <h5 className="m-0">{module.title}</h5>
              <span
                style={{
                  fontSize: "18px",
                  transform: activeModule === index ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              >
                ▼
              </span>
            </div>
            {activeModule === index && (
              <div
                className="p-3 bg-light border"
                style={{ borderRadius: "5px" }}
              >
                {module.content.map((item, i) => (
                  <p key={i} style={{ margin: "5px 0", fontSize: "14px" }}>
                    ➤ {item}
                  </p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default UnlockingMarketSecretsModule;
